import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-icons-block',
  templateUrl: './contact-icons-block.component.html',
  styleUrls: ['./contact-icons-block.component.scss']
})
export class ContactIconsBlockComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
